import { z } from "@hono/zod-openapi";
import type { JSX } from "hono/jsx";

// deno-lint-ignore no-explicit-any
interface InputProps extends JSX.HTMLAttributes {
  schema?: z.ZodTypeAny;
  error?: string;
  label?: string;
  containerClass?: string;
}

const getConstraints = (schema?: z.ZodTypeAny) => {
  if (!schema) return {};

  let target = schema;
  let required = true;

  // Unwrap optional/nullable/default
  while (true) {
    if (target instanceof z.ZodOptional || target instanceof z.ZodNullable) {
      target = (target as any).unwrap();
      required = false;
    } else if (target instanceof z.ZodDefault) {
      target = (target as any).removeDefault();
      required = false;
    } else {
      break;
    }
  }

  const constraints: {
    required?: boolean;
    minLength?: number;
    maxLength?: number;
  } = { required };

  if (target instanceof z.ZodString) {
    // deno-lint-ignore no-explicit-any
    const def = target._def as any;
    if (def.checks) {
      // deno-lint-ignore no-explicit-any
      for (const check of def.checks as any[]) {
        if (check.kind === "min") constraints.minLength = check.value;
        if (check.kind === "max") constraints.maxLength = check.value;
      }
    }
  }

  return constraints;
};

// deno-lint-ignore no-explicit-any
export const Input = (
  { schema, error, label, containerClass, class: className, ...props }: any,
) => {
  const constraints = getConstraints(schema);

  return (
    <div class={`form-control w-full ${containerClass || ""}`}>
      {label && (
        <label class="label">
          <span
            class={`label-text font-bold uppercase text-xs opacity-60 ${
              error ? "text-error" : ""
            }`}
          >
            {label}
          </span>
        </label>
      )}
      <input
        {...constraints}
        {...props}
        class={`input input-bordered w-full font-bold ${
          error ? "input-error" : ""
        } ${className || ""}`}
        onInput={(e) => {
          // console.log("Input inner onInput", (e.target as HTMLInputElement).value);
          props.onInput && props.onInput(e);
        }}
      />
      {error && (
        <label class="label">
          <span class="label-text-alt text-error font-bold">{error}</span>
        </label>
      )}
    </div>
  );
};
